export const safeRenderValue = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  
  if (Array.isArray(value)) {
    return value.map(safeRenderValue).join(', ');
  }
  
  if (typeof value === 'object') {
    if (value.NAME) return String(value.NAME);
    if (value.name) return String(value.name);
    if (value.value) return String(value.value);
    if (value.text) return String(value.text);
    
    const stringValues = Object.values(value)
      .filter(v => typeof v === 'string' || typeof v === 'number')
      .filter(v => v !== '')
      .slice(0, 3)
      .map(String)
      .join(', ');
    
    return stringValues || '';
  }
  
  return '';
};

export const renderBlockProperty = (value, fallback = '') => {
  const rendered = safeRenderValue(value);
  return rendered || fallback;
};

export const isValidString = (value) => {
  return typeof value === 'string' && value.length > 0;
};

export const getStringValue = (value, fallback = '') => {
  if (typeof value === 'string') return value;
  const rendered = safeRenderValue(value);
  return rendered || fallback;
};
